<script setup lang="ts">
type Props = {
  initialValue?: string;
  disabled?: boolean;
  userCurrency: string;
  userLanguage: string;
  userCountry: string;
  showCurrency?: boolean;
  size?: string;
};

const {
  initialValue = '',
  disabled = false,
  userCurrency,
  userLanguage,
  userCountry,
  showCurrency = false,
  size = 'md',
} = defineProps<Props>();

const modelValue = defineModel<string>('modelValue', {
  default: '',
});

const onInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;

  // Substituir vírgulas por pontos
  value = value.replace(',', '.');
  value = value.replace(',,', '.');
  value = value.replace('..', '.');
  value = value.replace(',.', '.');
  value = value.replace('.,', '.');

  // Verifica se o último caractere é um ponto para evitar a remoção prematura
  const lastChar = value.slice(-1);

  if (lastChar === '.' || lastChar === ',') {
    input.value = value; // Mantém o valor com ponto se for o último caractere
  } else {
    const parts = value.split('.');

    // Limitar a duas casas decimais
    if (parts[1] && parts[1].length > 2) {
      parts[1] = parts[1].slice(0, 2);
      value = parts.join('.');
    }

    modelValue.value = value || '';
  }
};

watchEffect(() => (modelValue.value = initialValue));
</script>

<template>
  <div :class="$style.inputContainer">
    <input
      v-model="modelValue"
      :class="[$style.inputCurrency, { [$style.lg]: size === 'lg' }]"
      density="compact"
      :disabled="disabled"
      inputmode="decimal"
      placeholder="Valor"
      step="0"
      type="text"
      variant="solo"
      @input="onInput"
    />
    <DepositCurrencyButton
      v-if="showCurrency"
      :class="[$style.currencyButton, { [$style.lg]: size === 'lg' }]"
      :user-country="userCountry"
      :user-currency="userCurrency"
      :user-language="userLanguage"
    />
  </div>
</template>

<style module lang="postcss">
.inputContainer {
  @apply w-full relative;

  .inputCurrency {
    @apply h-8 px-4 w-full text-sm border-none rounded-lg placeholder-auth-text-inputs/60 bg-auth-bg-inputs text-auth-text-inputs focus:border-transparent focus:outline-none focus:ring-0;

    &.lg {
      @apply h-12 text-base;
    }

    &[disabled]:not([disabled='false']) {
      @apply opacity-40 cursor-not-allowed;
    }
  }

  .currencyButton {
    @apply absolute top-1/2 -translate-y-1/2 right-3 w-auto h-full;

    &.lg {
      @apply right-5;
    }
  }
}
</style>
